import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { IDiscernSeachFields, IDiscernDetails, discernService, ILabelResultOne } from "./discernService";
import { ISearchPage } from "@/types/AppTypes";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { convertRes2Blob } from "@/utils/exportFile";
import moment from "moment";

interface IKeyWordsDrawerType {
    visible: boolean,
    mode: "add" | "edit",
    record?: ILabelResultOne
}

export const useDiscernModel = createModel(function () {
    const { setLoadingInfo } = useGlobalModel(() => [])
    //列表数据源
    const [dataSource, setDataSource] = useState<IDiscernDetails[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IDiscernSeachFields>({});
    //时间区间
    const [searchParamTime, setSearchParamTime] = useState<IDiscernSeachFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //行选id
    const [selectedRowKeys, setSelectedRowKeys] = useState<IDiscernDetails[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [showOne, setShowOne] = useState<boolean>(true);
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IDiscernSeachFields = searchParam, timeValue = searchParamTime) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            ...timeValue,
            // status: searchValue.status === "是" ? "1" : searchValue.status === "否" ? "0" : "",
            status:"1",
            isJoin: searchValue.isJoin === "是" ? "1" : searchValue.isJoin === "否" ? "0" : "",
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        try {
            let { retData } = await discernService.page(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            setLoading(false);
            return records;
        } catch (err) { setLoading(false) }
    }


    //导出
    const downloadFile = useLockFn(async (id?: string) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速下载中" });
        try {
            const searchParams = {
                id: id ?? selectedRowKeys.map(item => item.id)?.join(),
            }
            let result = await discernService.downloadFile(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch{
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    });

    /**标注页 */
    const [LabelResultDrawer, setLabelResultDrawer] = useState<IKeyWordsDrawerType>({ visible: false, mode: "add" });
    const [LabelInfoDrawer, setLabelInfoDrawer] = useState<boolean>(false);

    const [discernOne, setDiscernOne] = useState<IDiscernDetails>();
    const getDiscernOne = async (id: string) => {
        let { retData } = await discernService.distinguishOne(id);
        setDiscernOne(retData);
        if (retData && retData.seeStatus === 0) {
            discernService.distinguishUpdateSee({
                id: retData.id,
                seeStatus: 1,
                seeTime: moment().format('YYYY-MM-DD HH:mm:ss') 
            })
        };
        return retData;
    };

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg, loading,
        searchParamTime, setSearchParamTime,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        setSearchParam,
        loadData,
        /***标注页***/
        LabelResultDrawer, setLabelResultDrawer,
        LabelInfoDrawer, setLabelInfoDrawer,
        getDiscernOne, discernOne,
        downloadFile,
        showOne, setShowOne
    }
});